import { logout, getAuthToken } from "./auth";

const getAuthHeaders = (token) => ({
  Authorization: "Bearer " + token,
});

export const METHODS = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE",
};

class Api {
  constructor(apiBaseUrl) {
    this.apiBaseUrl = apiBaseUrl;
  }

  async fetch(method, url, headers, body = null) {
    const bodyObj = body && { body: JSON.stringify(body) };
    const idToken = await getAuthToken();
    const authHeaders = getAuthHeaders(idToken);

    return fetch(`${this.apiBaseUrl}${url}`, {
      method,
      headers: {
        ...authHeaders,
        Accept: "application/json",
        "Content-Type": "application/json",
        ...headers,
      },
      ...bodyObj,
    })
      .then((res) => {
        if (res.ok) return res.json();

        return res
          .json()
          .catch(() => Promise.reject(res))
          .then((json) => Promise.reject(json));
      })
      .catch((err) => {
        if (err.status === 401) {
          logout();
        }
        throw err;
      });
  }

  get(...args) {
    return this.fetch(METHODS.GET, ...args);
  }

  post(...args) {
    return this.fetch(METHODS.POST, ...args);
  }

  put(...args) {
    return this.fetch(METHODS.PUT, ...args);
  }

  delete(...args) {
    return this.fetch(METHODS.DELETE, ...args);
  }
}

const api = new Api(process.env.REACT_APP_API_BASE_DOMAIN);
const optimiseApi = new Api(process.env.REACT_APP_API_OPTIMISE_DOMAIN);

export default api;
export { optimiseApi };
